import shared from './shared'
import { GrupeUtils } from '../utils/grupeUtils'

export default {
    shared,
    async createUserGroup (createUserGrupaRequest) {
        try {
            GrupeUtils.validateCreateUserGrupaRequest(createUserGrupaRequest)
            const createUserGrupa = this.shared.functions().httpsCallable('createUserGroup')
            let data = await createUserGrupa(createUserGrupaRequest)
            return data.data
        } catch (error) {
            console.log(error)
            return false
        }
    },
    async deleteUserGrupa (deleteUserGroupRequest) {
        try {
            GrupeUtils.validateDeleteUserGrupeRequest(deleteUserGroupRequest)
            const deleteUserGroup = this.shared.functions().httpsCallable('deleteUserGroup')
            let data = await deleteUserGroup(deleteUserGroupRequest)
            return data.data
        } catch (error) {
            console.log(error)
            return false
        }
    },

    async joinUserGroup (joinUserGroupRequest) {
        try {
            GrupeUtils.validateJoinUserGrupeRequest(joinUserGroupRequest)
            const joinUserGroup = this.shared.functions().httpsCallable('joinUserGroup')
            let data = await joinUserGroup(joinUserGroupRequest)
            return data.data
        } catch (error) {
            console.log(error)
            return false
        }
    },

    async removeUserFromGroup (removeUserFromGroupRequest) {
        try {
            GrupeUtils.validateRemoveUserFromGrupeRequest(removeUserFromGroupRequest)
            const removeUserFromGroup = this.shared.functions().httpsCallable('removeUserFromGroup')
            let data = await removeUserFromGroup(removeUserFromGroupRequest)
            return data.data
        } catch (error) {
            console.error(error)
            return false
        }
    },

    async getGroupName (groupId) {
        try {
            if (!groupId) {
                return false
            }
            let groupNameRef = await this.shared.db().ref(`/userGroups/${groupId}/name`).once('value')
            return groupNameRef.val()
        } catch (error) {
            console.log(error)
            return false
        }
    },
    async getGroupNatjecatelji (groupId) {
        try {
            if (!groupId) {
                return false
            }
            let groupNatjecateljiRef = await this.shared.db().ref(`/userGroups/${groupId}/members`).once('value')
            let groupNatjecateljiData = groupNatjecateljiRef.exportVal()
            if (!groupNatjecateljiData) {
                groupNatjecateljiData = {}
            }
            return groupNatjecateljiData
        } catch (error) {
            console.error(error)
            return false
        }
    },

    async getGroupNameAndNatjecateljiCount (groupId) {
        try {
            if (!groupId) {
                return false
            }
            let groupRef = await this.shared.db().ref(`/userGroups/${groupId}`).once('value')
            let group = groupRef.exportVal()
            if (!group) {
                group = {}
            }
            let natjecateljiKeys = Object.values(group.members)
            let count = natjecateljiKeys.length
            let groupName = group.name
            return {
                groupName,
                count
            }
        } catch (error) {
            console.log(error)
            return false
        }
    },

    async getAllMyGroupIds (uid) {
        try {
            if (!uid) {
                return false
            }
            let groupsRef = await this.shared.db().ref(`/users/${uid}/inGroups`).once('value')
            let groups = groupsRef.exportVal()
            if (!groups) {
                groups = {}
            }
            groups = Object.values(groups)
            return groups
        } catch (error) {
            console.log(error)
            return false
        }
    }
}
